import React, {useState} from 'react'
import { ReactSVG } from 'react-svg'
import { Redirect } from 'react-router-dom';
import './Login.scss'
export default function Login (props){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isPassword, setIsPassword] = useState(true);
  const [loginError, setLoginError] = useState('');
  const [redirectToReferrer, setRedirectToReferrer] = useState(false);
   const handleInputChange = cb => event => {
    cb(event.target.value)
  };

  const loginUser = (user, history) => {
    let url = 'https://staging.s3ntin3l.com/mobile/app/ecustomer/v1/api/login';
    fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(user)
    })
    .then(response=>{
      return response.json();
    })
    .then(data=>{
      if(!data.data) {
        setLoginError('Username or password is incorrect');
        return;
      }
      if(data.data.session_key) {
        if(!window.localStorage.session_key) {
          window.localStorage.setItem('session_key', data.data.session_key);
          window.localStorage.setItem('email', data.data.user.email_address);
        }
        setRedirectToReferrer(true);
      }
    });
  };

  function handleLogin() {
    const user = {
      email_address: email,
      password: password
    };
    loginUser(user, props.history);
  }

  const { from } = props.location.state || { from: { pathname: '/' } }
  
  if (redirectToReferrer === true) {
    return <Redirect to={from} />
  }

  return (
    <div className="login-page-container">
      <div className="login-page-content">
        <div className="logo-container">
          <ReactSVG src={require("../assets/red_logo.svg")} />
        </div>
        <div className="title">Login</div>
        <div className="form-container">
          <div className="email-container">
            <input autoComplete="new-password" type="hidden" type="text" value={email} placeholder="Email" onChange={handleInputChange(setEmail)} className="email-input"/>
          </div>
          <div className="password-container">
            <input autoComplete="new-password" type={isPassword ? "password" : "text"} value={password} placeholder="Password" onChange={handleInputChange(setPassword)} className="password-input"/>
            <div className="password-eye-container" onClick={()=>{setIsPassword(!isPassword)}}>
              {
                isPassword ? <ReactSVG src={require("../assets/hide_icon.svg")} /> : <ReactSVG src={require("../assets/show_icon.svg")} />
              }
            </div>
          </div>
          <div className="forgot-password">Forgot password?</div>
          { loginError && <div className="login-error">{loginError}</div> }
        <div className="login-button-container">
          <div className="login-button" onClick={handleLogin}>Login</div>
        </div>
        </div>
      </div>
      </div>
  )
}